import React from "react";
import ConsultantWork from "@/pages/dashboard/ConsultantWork";
const Consultor = () => <ConsultantWork dashboard />;
export default Consultor;
